<template>
    <div id="newsletter">
        <div class="wrap-newsletter">
            <div>
                <h3 class="tx-white">Newsletter</h3>
                <p class="tx-white">Yuk jadi orang pertama yang mengetahui info produk dan promo terbaru sepeda motor
                    Honda</p>
                <a class="btn-submit btn-red" @click="trackerLayer" href="/community/newsletter">Subscribe</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        trackerLayer() {
            var data = {
                'event': 'newSubscription',
                'eventDetail.category': 'New Newsletter Subscription',
                'eventDetail.action': 'Start Subscribe',
                'eventDetail.label': 'Click Button Subscribe',
                'pageURL': window.location.href
            }
            dataLayer.push(data);
        }
    }
}
</script>>

<style scoped>
.message {
    text-align: center;
}

form input,
form textarea,
.aselect,
.label {
    color: #727272 !important;
    width: 100%;
}

input::placeholder {
    color: #727272;
}

form input,
form textarea,
.label {
    border-radius: 4px;
    padding: 8px 15px;
    color: #727272;
}

.btn-submit {
    border: none;
    font-weight: 500;
    letter-spacing: 0.08em;
    cursor: pointer;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.3);
    transition: 0.25s all ease;
    padding: 12px 25px;
    font-size: 14px;
    border-radius: 10px;
    margin-top: 20px;
}

.btn-submit:hover {
    -webkit-transform: translateY(2px);
    transform: translateY(2px);
}

.active {
    background: #5968d7;
}

pre-content {
    width: 500px;
}

.aselect .selector .arrow {
    position: absolute;
    right: 10px;
    top: 40%;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 7px solid #E61B33;
    transform: rotateZ(0deg) translateY(0px);
    transition-duration: 0.3s;
    transition-timing-function: cubic-bezier(0.59, 1.39, 0.37, 1.01);
}

.aselect .selector .expanded {
    transform: rotateZ(180deg) translateY(2px);
}

.aselect ul {
    width: 100%;
    list-style-type: none;
    padding: 0;
    margin: 0;
    font-size: 14px;
    border: 1px solid #727272;
    position: absolute;
    z-index: 1;
    background: #fff;
}

.aselect li {
    padding: 8px 12px;
    font-size: 12px;
    color: #727272;
}

.aselect li:hover {
    color: white;
    background: #E61B33;
}

.aselect .current {
    background: #eaeaea;
}

.aselect .hidden {
    visibility: hidden;
}

.aselect .visible {
    visibility: visible;
}


/* custom */
.selector {
    position: relative;
}

.aselect {
    background-color: #fff;
    cursor: pointer;
    font-size: 12px;
}

#newsletter {
    background-color: #202020;
    border-radius: 10px;
}

#newsletter h3 {
    margin-top: 0;
}

#newsletter p {
    line-height: 25px;
    font-size: 13px;
    font-weight: 300;
    margin-bottom: 2em;
}

.wrap-newsletter {
    padding: 2em 3em 4em;
}

.form-item {
    margin-bottom: 15px;
}

.form-item:last-child {
    margin-bottom: 0;
}

.form-input {
    border-radius: 10px;
    height: 32px;
}
</style>
